<template>
  <div id="box">
    <vxe-button type="primary" size="small" style="margin-bottom: 10px" @click="addPro()">新增省级
    </vxe-button>
    <div class="common-shadow clearfix">
      <Row style="height: 560px;background-color: white;">
        <Col span="8" style="height: 560px;border-right: 1px solid #e4e3e3;">
          <List :split="false">
            <template slot="header">
              <div class="headerFlex">
                <span style="font-size:14px">省级</span>
              </div>
            </template>
            <div style="padding-left: 20px;" class="scrollY">
              <ListItem v-for="(item,index) in tableData" :key="index" style="height: 50px;">
                <span style="display: flex;justify-content: center;width: 10%;">{{ item.id }}</span>
                <div style="display: flex;
    width: 55%;
    justify-content: center;
    flex-flow: column;
align-items: center;">
                  <div>{{ item.cityText }}</div>
                </div>
                <div style="display: flex;justify-content: center;
    width: 25%;font-size: 16px;">
                  <Icon type="ios-trash" @click="del(item,0)" style="padding-right: 5px;color: #ED4014"></Icon>
                  <Icon type="ios-create-outline" @click="modify(item)"
                        style="padding-right: 5px;color: #438DF3"></Icon>
                  <Icon type="ios-add-circle-outline" @click="addCity(item)" style="color: #438DF3"></Icon>
                </div>
                <Icon type="ios-arrow-forward" @click="getList(item.cityCode,1)" style="display: flex;
                        width: 5%;justify-content: flex-end;cursor:pointer"></Icon>
              </ListItem>
            </div>
          </List>
        </Col>
        <Col span="8" style="height: 560px;border-right: 1px solid #e4e3e3;">
          <List :split="false">
            <div class="headerFlex">
              <span style="font-size:14px">市级</span>
            </div>
            <div style="padding-left: 20px;" class="scrollY">
              <ListItem v-for="(item,index) in cityData" :key="index" style="height: 50px">
                    <span style="display: flex;justify-content: center;
    width: 10%;">{{ item.id }}</span>
                <div style="display: flex;
    width: 55%;
    justify-content: center;
    flex-flow: column;
align-items: center;">
                  <div>{{ item.cityText }}</div>
                </div>
                <div style="display: flex;justify-content: center;
    width: 25%;font-size: 16px;">
                  <Icon type="ios-trash" @click="del(item,1)" style="padding-right: 5px;color: #ED4014"></Icon>
                  <Icon type="ios-create-outline" @click="modifyCity(item)"
                        style="padding-right: 5px;color: #438DF3"></Icon>
                  <Icon type="ios-add-circle-outline" @click="addPort(item)" style="color: #438DF3"></Icon>
                </div>
                <Icon type="ios-arrow-forward" @click="getList(item.cityCode,2)" style="display: flex;
                        width: 5%;justify-content: flex-end;cursor:pointer"></Icon>
              </ListItem>
            </div>
          </List>
        </Col>
        <Col span="8" style="height: 500px">
          <List :split="false">
            <template slot="header">
              <div class="headerFlex">
                <span style="font-size:14px">区县级</span>
              </div>
            </template>
            <div style="padding-left: 20px;" class="scrollY">
              <ListItem v-for="(item,index) in proData" :key="index" style="height: 50px">
                <span style="display: flex;justify-content: center;
    width: 10%;">{{ item.id }}</span>
                <div style="display: flex;
    width: 55%;
    justify-content: center;
    flex-flow: column;
align-items: center;">
                  <div>{{ item.cityText }}</div>
                </div>
                <div style="display: flex;justify-content: center;
    width: 25%;">
                  <Icon type="ios-trash" @click="del(item,2)" style="padding-right: 5px;color: #ED4014"></Icon>
                  <Icon type="ios-create-outline" @click="modifyPort(item)"
                        style="padding-right: 5px;color: #438DF3"></Icon>
                </div>
              </ListItem>
            </div>
          </List>
        </Col>
      </Row>
      <vxe-modal v-model="dialogFormVisible" :title="title" width="520" min-height="280" resize destroy-on-close
                 position="center">
        <vxe-form ref="xForm" class="my-form2" title-align="right" :data="form" :rules="formRules"
                  @submit="confirMenu">
          <vxe-form-item :title="name" field="cityText" span="22" title-width="120">
            <template>
              <vxe-input v-model="form.cityText" placeholder="请填写(必填)"></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item :title="code" field="cityCode" span="22" title-width="120">
            <template>
              <vxe-input v-model="form.cityCode" placeholder="请填写(必填)"></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="排序" field="orderby" span="22" title-width="120">
            <template>
              <vxe-input v-model="form.orderby" placeholder="请填写"></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item align="right" span="24">
            <template v-slot>
              <vxe-button @click="dialogFormVisible = false">取 消</vxe-button>
              <vxe-button type="submit" status="primary">确 定</vxe-button>
            </template>
          </vxe-form-item>
        </vxe-form>
      </vxe-modal>
    </div>
  </div>

</template>

<script>
import $api from "@/apiProvider";
import {showLoading, hideLoading} from '@/utils/util';
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  name: "PortDatabase",
  mixins: [getAuthOrization],
  data() {
    return {
      expands: [],
      tableData: [],
      form: {
        id: "",
        lv: 1,
        pCode: 0,
        seaArea: 1,
        portList: [{
          nameEn: ""
        }
        ]
      },
      seaAreaList: [],
      formRules: {
        cityText: [{required: true, message: "请填写"}],
        cityCode: [{required: true, message: "请填写"}],
      },
      dialogFormVisible: false,
      formData: {},
      data: {
        page: 1,
        rows: 500,
        pCode: 0
      },
      cityData: [],
      proData: [],
      title: "新增省级",
      name: "省级名称",
      code: "省代码",
      cityCodeP: 0,
      type: null
    }
  },
  created() {
    this.$bus.$on("行政区划表", () => {
      this.getList();
    });
    this.getList();
  },
  methods: {
    async getList(cityCodeP = 0, type) {
      showLoading()
      let res = await $api.xcwDict.request('queryProCityAreaList', {
        cityCodeP: cityCodeP
      });
      hideLoading();
      if (res.code === 1) {
        if (!type) {
          this.tableData = res.data;
          this.cityData = [];
          this.proData = [];
        } else if (type === 1) {
          this.cityData = res.data;
          this.proData = [];
        } else if (type === 2) {
          this.proData = res.data;
        }
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    del(row, lv) {
      this.$XModal.confirm("您确定要删除吗？").then((type) => {
        if (type === "confirm") {
          this.delComit(row, lv);
        }
      })
    },
    async delComit(row, type) {
      showLoading()
      let res = await $api.xcwDict.request('removeProCityAreaList', {
        id: row.id
      });
      hideLoading();
      if (res.code === 1) {
        this.$Message.success("删除成功");
        this.getList(row.cityCodeP, type);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    addPro() {
      //新增省
      this.dialogFormVisible = true;
      this.title = "新增省级";
      this.form = {
        cityCode: null,
        cityCodeP: 0,
        cityText: null
      };
      this.flag = 1;
      this.name = "省级名称";
      this.code = "省代码";
      this.cityCodeP = 0;
      this.type = null;
    },
    addCity(row) {
      //增加城市
      this.dialogFormVisible = true;
      this.flag = 1;
      this.title = "新增市级";
      this.form = {
        cityCode: null,
        cityCodeP: row.cityCode,
        cityText: null
      };
      this.cityCodeP = row.cityCode;
      this.type = 1;
      this.name = "市级名称";
      this.code = "市代码";
    },
    addPort(row) {
      this.dialogFormVisible = true;
      this.flag = 1;
      this.title = "新增区县";
      this.form = {
        cityCode: null,
        cityCodeP: row.cityCode,
        cityText: null
      };
      this.cityCodeP = row.cityCode;
      this.type = 2;
      this.name = "区县名称";
      this.code = "区县代码";
    },
    modify(rows) {
      this.dialogFormVisible = true;
      this.flag = 2;
      this.name = "省级名称";
      this.code = "省代码";
      this.title = "修改省级";
      this.form = Object.assign({}, rows);
      this.cityCodeP = 0;
      this.type = null;
    },
    modifyCity(rows) {
      this.dialogFormVisible = true;
      this.flag = 2;
      this.name = "市级名称";
      this.code = "市代码";
      this.title = "修改市级";
      this.form = Object.assign({}, rows);
      this.cityCodeP = rows.cityCodeP;
      this.type = 1;
    },
    modifyPort(rows) {
      this.dialogFormVisible = true;
      this.flag = 2;
      this.name = "区县名称";
      this.code = "区县代码";
      this.title = "修改区县";
      this.form = Object.assign({}, rows);
      this.cityCodeP = rows.cityCodeP;
      this.type = 2;
    },
    async createProCityArea() {
      showLoading()
      let res = await $api.xcwDict.request('createProCityArea', this.form);
      hideLoading();
      if (res.code === 1) {
        this.loading = false;
        this.dialogFormVisible = false;
        this.$Message.success("添加成功");
        this.getList(this.cityCodeP, this.type);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async updateProCityAreaList() {
      showLoading()
      let res = await $api.xcwDict.request('updateProCityAreaList', this.form);
      hideLoading();
      if (res.code === 1) {
        this.loading = false;
        this.dialogFormVisible = false;
        this.$Message.success("修改成功");
        this.getList(this.cityCodeP, this.type);
      } else {
        this.loading = false;
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    confirMenu() {
      if (this.flag === 1) {
        this.createProCityArea();
      }
      if (this.flag === 2) {
        this.updateProCityAreaList();
      }
    },
  }
}
</script>

<style>
.headerFlex {
  display: flex;
  background-color: rgb(248, 248, 249);
  height: 50px;
  align-items: center;
  justify-content: center;
  color: #808695;
}

.ivu-list-footer, .ivu-list-header {
  padding-top: 0px;
  padding-bottom: 0px;
}

.flexCenter {
  display: flex;
  justify-content: center
}

.scrollY {
  height: 507px;
  overflow-x: hidden;
  overflow-y: scroll;
}

#box::-webkit-scrollbar {
  display: none;
}
</style>